import React from "react";
import _ from "lodash";
import applyDiscount from "../utils/apply-discount";
import { US_STATES, AU_STATES, STRIPE } from "../constants";
import UpgradeConfirmationModal from "../parts/modals/upgrade-confirmation";

const { PRICES } = STRIPE;

class Upgrade2 extends React.Component {
  constructor(props) {
    super(props);
    const { query, activeUser } = props;

    this.state = {
      payPeriod: "monthly",
      plan: this.getPlan("monthly", query.plan),
      countrySelected: _.get(activeUser, "country", "CA"),
    };

    this.handlePeriodToggle = this.handlePeriodToggle.bind(this);
    this.handleCountrySelect = this.handleCountrySelect.bind(this);
  }

  getPlan(payPeriod, selectedPlanType) {
    let plan = "";
    if (payPeriod === "monthly") {
      plan =
        selectedPlanType === "standard"
          ? "v2_standard_monthly"
          : "v2_premium_monthly";
    } else {
      plan =
        selectedPlanType === "standard"
          ? "v2_standard_annually"
          : "v2_premium_annually";
    }
    return plan;
  }

  handlePeriodToggle() {
    const payPeriod =
      this.state.payPeriod === "monthly" ? "annually" : "monthly";
    this.setState({
      payPeriod,
      plan: this.getPlan(payPeriod, this.state.selectedPlanType),
    });
  }

  handleCountrySelect(e) {
    this.setState({ countrySelected: e.target.value });
  }

  render() {
    const { locals } = this.context;
    const {
      query,
      momentTZ,
      getCountryName,
      countries: countryOptions,
      activeUser,
      activeUserToRequest
    } = locals;
    const coupon = query.coupon || _.get(locals, "activeUserToRequest.stripe.coupon");
    const couponError = query.couponError;
    const hasCoupon = Boolean(_.get(coupon, "id"));
    const hasCouponError = Boolean(couponError);
    const isCouponApplied =
      _.get(coupon, "id") === _.get(locals, "activeUserToRequest.stripe.coupon.id");
    const selectedPlanType = query.plan === "premium" ? "premium" : "standard";

    // Plan costs
    const plan12MonthCost = applyDiscount(PRICES.twelveMonths, coupon);
    const plan3MonthCost = applyDiscount(PRICES.threeMonths, coupon);
    const plan1MonthCost = applyDiscount(PRICES.oneMonth, coupon);

    const planCostMonthly = applyDiscount(
      PRICES[
        selectedPlanType === "premium"
          ? "v2_premium_monthly"
          : "v2_standard_monthly"
      ],
      coupon
    );
    const planCostAnnually = applyDiscount(
      PRICES[
        selectedPlanType === "premium"
          ? "v2_premium_annually"
          : "v2_standard_annually"
      ],
      coupon
    );

    return (
      <div id="login-wrapper">
        <form method="POST" data-noreset>
          <img
            className="logo"
            src="/img/msb-logo-white.svg"
            alt="My Stength Book"
          />
          <div className="frame">
            <div className="head alt-upgrade">
              <p>
                You have chosen the{" "}
                {query.plan === "standard" ? "Standard" : "Premium"}{" "}
                Subscription
                <br />
                <a href="/upgrade-1">Change selection</a>
              </p>
            </div>

            <input type="hidden" name="plan" value={this.state.plan} />

            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="Payment-Selector-2">
                  <label className="plan">
                    <input type="radio" name="cycle" defaultChecked value="" />
                    <span className="details">
                      <span className="radio" />
                      <span className="text">Pay Monthly</span>
                      <span className="price">
                        ${planCostMonthly.toFixed(2)} USD
                      </span>
                    </span>
                  </label>

                  <label className="plan">
                    <input
                      type="radio"
                      name="cycle"
                      defaultChecked=""
                      value=""
                    />
                    <span className="details">
                      <span className="radio" />
                      <span className="text">Pay Annually</span>
                      <span className="rebate">10% OFF</span>
                      <span className="price">
                        ${planCostAnnually.toFixed(2)} USD
                      </span>
                    </span>
                  </label>
                </div>
              </div>

              <div className="Upgrade-Address">
                <div className="columns">
                  <div className="column" data-col="1/1">
                    <div className="label">Billing Address</div>
                    <input
                      className="text-input"
                      name="source[address_line1]"
                      type="text"
                      placeholder="Address Line 1"
                    />
                    <input
                      className="text-input"
                      name="source[address_line2]"
                      type="text"
                      placeholder="Address Line 2"
                    />
                  </div>

                  <div className="column" data-col="1/2">
                    <input
                      className="text-input"
                      name="source[address_city]"
                      type="text"
                      placeholder="City"
                    />
                  </div>

                  {this.state.countrySelected === "CA" && (
                    <div className="column" data-col="1/4">
                      <select
                        className="text-input"
                        type="text"
                        name="source[address_state]"
                        placeholder="Province"
                      >
                        <option disabled value="">
                          Province
                        </option>
                        <option value="AB">Alberta</option>
                        <option value="BC">British Columbia</option>
                        <option value="MB">Manitoba</option>
                        <option value="NB">New Brunswick</option>
                        <option value="NL">Newfoundland and Labrador</option>
                        <option value="NS">Nova Scotia</option>
                        <option value="ON">Ontario</option>
                        <option value="PE">Prince Edward Island</option>
                        <option value="QC">Quebec</option>
                        <option value="SK">Saskatchewan</option>
                        <option value="NT">Northwest Territories</option>
                        <option value="NU">Nunavut</option>
                        <option value="YT">Yukon</option>
                      </select>
                    </div>
                  )}

                  {this.state.countrySelected === "US" && (
                    <div className="column" data-col="1/4">
                      <select
                        className="text-input"
                        type="text"
                        name="source[address_state]"
                      >
                        <option disabled value="">
                          State
                        </option>
                        {US_STATES.map((state) => (
                          <option value={state.abbreviation}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {this.state.countrySelected === "AU" && (
                    <div className="column" data-col="1/4">
                      <select
                        className="text-input"
                        type="text"
                        name="source[address_state]"
                        defaultValue=""
                      >
                        <option disabled value="">
                          State
                        </option>
                        {AU_STATES.map((state) => (
                          <option value={state.abbreviation}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {["AU", "CA", "US"].indexOf(this.state.countrySelected) ==
                    -1 && (
                    <div className="column" data-col="1/4">
                      <input
                        className="text-input"
                        name="source[address_state]"
                        type="text"
                        placeholder="State"
                      />
                    </div>
                  )}

                  <div className="column" data-col="1/4">
                    <input
                      className="text-input"
                      name="source[address_zip]"
                      type="text"
                      placeholder={
                        this.state.countrySelected === "US"
                          ? "Zip Code"
                          : "Postal Code"
                      }
                    />
                  </div>

                  <div className="column" data-col="1/1">
                    <select
                      required
                      name="source[address_country]"
                      className="select-input"
                      defaultValue={_.get(activeUser, "country", "")}
                      onChange={(e) => this.handleCountrySelect(e)}
                    >
                      <option hidden disabled value="">
                        Location
                      </option>
                      {_.map(countryOptions, (code) => {
                        return (
                          <option key={code} value={code}>
                            {getCountryName(code)}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <hr />

                  <div className="column" data-col="1/1">
                    <div className="label">Time Zone</div>
                    <select className="select-input" name="timeZone">
                      <option value="-12">
                        (GMT-12:00) International Date Line West
                      </option>
                      <option value="-11">
                        (GMT-11:00) Midway Island, Samoa
                      </option>
                      <option value="-10">(GMT-10:00) Hawaii</option>
                      <option value="-9">(GMT-09:00) Alaska</option>
                      <option value="-8a">
                        (GMT-08:00) Pacific Time (US & Canada)
                      </option>
                      <option value="-8b">
                        (GMT-08:00) Tijuana, Baja California
                      </option>
                      <option value="-7a">(GMT-07:00) Arizona</option>
                      <option value="-7b">
                        (GMT-07:00) Chihuahua, La Paz, Mazatlan
                      </option>
                      <option value="-7c">
                        (GMT-07:00) Mountain Time (US & Canada)
                      </option>
                      <option value="-6a">(GMT-06:00) Central America</option>
                      <option value="-6b">
                        (GMT-06:00) Central Time (US & Canada)
                      </option>
                      <option value="-6c">
                        (GMT-06:00) Guadalajara, Mexico City, Monterrey
                      </option>
                      <option value="-6d">(GMT-06:00) Saskatchewan</option>
                      <option value="-5a">
                        (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                      </option>
                      <option value="-5b">
                        (GMT-05:00) Eastern Time (US & Canada)
                      </option>
                      <option value="-5c">(GMT-05:00) Indiana (East)</option>
                      <option value="-4a">
                        (GMT-04:00) Atlantic Time (Canada)
                      </option>
                      <option value="-4b">(GMT-04:00) Caracas, La Paz</option>
                      <option value="-4c">(GMT-04:00) Manaus</option>
                      <option value="-4d">(GMT-04:00) Santiago</option>
                      <option value="-3.5">(GMT-03:30) Newfoundland</option>
                      <option value="-3a">(GMT-03:00) Brasilia</option>
                      <option value="-3b">
                        (GMT-03:00) Buenos Aires, Georgetown
                      </option>
                      <option value="-3c">(GMT-03:00) Greenland</option>
                      <option value="-3d">(GMT-03:00) Montevideo</option>
                      <option value="-2a">(GMT-02:00) Mid-Atlantic</option>
                      <option value="-1a">(GMT-01:00) Cape Verde Is.</option>
                      <option value="-1b">(GMT-01:00) Azores</option>
                      <option value="0a">
                        (GMT+00:00) Casablanca, Monrovia, Reykjavik
                      </option>
                      <option value="0b">
                        (GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh,
                        Lisbon, London
                      </option>
                      <option value="1a">
                        (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm,
                        Vienna
                      </option>
                      <option value="1b">
                        (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana,
                        Prague
                      </option>
                      <option value="1c">
                        (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                      </option>
                      <option value="1d">
                        (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb
                      </option>
                      <option value="1e">
                        (GMT+01:00) West Central Africa
                      </option>
                      <option value="2a">(GMT+02:00) Amman</option>
                      <option value="2b">
                        (GMT+02:00) Athens, Bucharest, Istanbul
                      </option>
                      <option value="2c">(GMT+02:00) Beirut</option>
                      <option value="2d">(GMT+02:00) Cairo</option>
                      <option value="2e">(GMT+02:00) Harare, Pretoria</option>
                      <option value="2f">
                        (GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn,
                        Vilnius
                      </option>
                      <option value="2g">(GMT+02:00) Jerusalem</option>
                      <option value="2h">(GMT+02:00) Minsk</option>
                      <option value="2i">(GMT+02:00) Windhoek</option>
                      <option value="3a">
                        (GMT+03:00) Kuwait, Riyadh, Baghdad
                      </option>
                      <option value="3b">
                        (GMT+03:00) Moscow, St. Petersburg, Volgograd
                      </option>
                      <option value="3c">(GMT+03:00) Nairobi</option>
                      <option value="3d">(GMT+03:00) Tbilisi</option>
                      <option value="3.5">(GMT+03:30) Tehran</option>
                      <option value="4a">(GMT+04:00) Abu Dhabi, Muscat</option>
                      <option value="4b">(GMT+04:00) Baku</option>
                      <option value="4c">(GMT+04:00) Yerevan</option>
                      <option value="4.5">(GMT+04:30) Kabul</option>
                      <option value="5a">(GMT+05:00) Yekaterinburg</option>
                      <option value="5b">
                        (GMT+05:00) Islamabad, Karachi, Tashkent
                      </option>
                      <option value="5.5a">
                        (GMT+05:30) Sri Jayawardenapura
                      </option>
                      <option value="5.5b">
                        (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                      </option>
                      <option value="5.75">(GMT+05:45) Kathmandu</option>
                      <option value="6a">
                        (GMT+06:00) Almaty, Novosibirsk
                      </option>
                      <option value="6b">(GMT+06:00) Astana, Dhaka</option>
                      <option value="6.5">(GMT+06:30) Yangon (Rangoon)</option>
                      <option value="7a">
                        (GMT+07:00) Bangkok, Hanoi, Jakarta
                      </option>
                      <option value="7b">(GMT+07:00) Krasnoyarsk</option>
                      <option value="8a">
                        (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                      </option>
                      <option value="8b">
                        (GMT+08:00) Kuala Lumpur, Singapore
                      </option>
                      <option value="8c">
                        (GMT+08:00) Irkutsk, Ulaan Bataar
                      </option>
                      <option value="8d">(GMT+08:00) Perth</option>
                      <option value="8e">(GMT+08:00) Taipei</option>
                      <option value="9a">
                        (GMT+09:00) Osaka, Sapporo, Tokyo
                      </option>
                      <option value="9b">(GMT+09:00) Seoul</option>
                      <option value="9c">(GMT+09:00) Yakutsk</option>
                      <option value="9.5">(GMT+09:30) Adelaide</option>
                      <option value="9.5">(GMT+09:30) Darwin</option>
                      <option value="10a">(GMT+10:00) Brisbane</option>
                      <option value="10b">
                        (GMT+10:00) Canberra, Melbourne, Sydney
                      </option>
                      <option value="10c">(GMT+10:00) Hobart</option>
                      <option value="10d">
                        (GMT+10:00) Guam, Port Moresby
                      </option>
                      <option value="10e">(GMT+10:00) Vladivostok</option>
                      <option value="11a">
                        (GMT+11:00) Magadan, Solomon Is., New Caledonia
                      </option>
                      <option value="12a">
                        (GMT+12:00) Auckland, Wellington
                      </option>
                      <option value="12b">
                        (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                      </option>
                      <option value="13a">(GMT+13:00) Nuku alofa</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="Upgrade">
                <hr />

                <label>Change Credit Card</label>
                <div className="display">
                  <div className="column" data-col="1/1">
                    <div className="label">Credit Card Number</div>
                    <input
                      type="text"
                      name="source[number]"
                      className="text-input fs-hide"
                      placeholder="Credit Card Number"
                    />
                  </div>

                  <div className="column" data-col="1/4">
                    <div className="label">Expiry</div>
                    <input
                      type="text"
                      name="source[exp]"
                      className="text-input fs-hide"
                      placeholder="MM/YY"
                    />
                  </div>

                  <div className="column" data-col="1/4">
                    <div className="label">Security&nbsp;Code</div>
                    <input
                      type="text"
                      name="source[cvc]"
                      className="text-input fs-hide"
                      placeholder="CVC"
                    />
                  </div>
                </div>
              </div>

              {hasCoupon ? (
                <div className="Upgrade-Coupon">
                  <div className="column" data-col="2/3">
                    <div className="label">Coupon Code</div>
                    <input
                      className="text-input fs-hide"
                      type="text"
                      name="couponCode"
                      defaultValue={coupon.id}
                      readOnly={isCouponApplied}
                    />
                    {hasCouponError ? (
                      <div className="coupon-msg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                        >
                          <g fill="#E23914">
                            <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                            <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                          </g>
                        </svg>
                        {couponError}
                      </div>
                    ) : (
                      <div className="coupon-msg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                        >
                          <g fill="#75C454">
                            <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                            <polygon points="11.5 16 6.5 11.1 5.1 12.5 10.1 17.5 10.1 17.6 10.8 18.2 11.5 18.9 11.5 18.9 11.6 18.9 12.2 18.2 12.9 17.5 12.9 17.5 20.4 8.9 18.9 7.6 11.5 16" />
                          </g>
                        </svg>
                        {coupon.description}
                      </div>
                    )}
                  </div>
                  <div className="column" data-col="1/3">
                    <div className="label" />
                    {isCouponApplied ? (
                      <button type="submit" name="button" value="remove-coupon">
                        Remove
                      </button>
                    ) : (
                      <button
                        className="button-input full alt"
                        type="submit"
                        name="button"
                        value="validate-coupon"
                      >
                        Validate
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="Upgrade-Coupon">
                  <div className="column" data-col="2/3">
                    <div className="label">Coupon Code</div>
                    <input
                      className="text-input fs-hide"
                      type="text"
                      name="couponCode"
                    />
                    {hasCouponError && (
                      <div className="coupon-msg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                        >
                          <g fill="#E23914">
                            <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                            <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                          </g>
                        </svg>
                        {couponError}
                      </div>
                    )}
                  </div>
                  <div className="column" data-col="1/3">
                    <div className="label" />
                    <button
                      className="button-input full alt"
                      type="submit"
                      name="button"
                      value="validate-coupon"
                    >
                      Validate
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="foot">
              <button className="button-input full" type="submit">
                Upgrade
              </button>
            </div>
          </div>
          <div className="login-signup">
            Don't plan on upgrading? <a href="/feedback">Tell us why.</a>
          </div>
        </form>
      </div>
    );
  }
}

const Upgrade2Controller = (app) => {
  app.get("/upgrade-2", ({ res, locals, flash, momentTZ }) => {
    const { activeUser, query, activeUserToRequest } = locals;
    const plan = _.get(activeUserToRequest, "stripe.plan", false);
    if (!activeUser) {
      res.redirect("/login");
      return;
    }

    // if the user's plan is a paid account, redirect them to see their subscription
    if (!_.includes(["none", "launch_freeTrial", "free_trial"], plan)) {
      res.redirect("/dashboard/settings/subscription");
    }

    const modal = _.get(query, "modal", {});
    locals.modal = {
      "upgrade-confirmation": <UpgradeConfirmationModal />,
    }[modal.type];

    // if the user's subcbription has ended, they have cancelled and restarted or someone deleted their subscription in stripe
    // we need to use todays date for the retention date to make sense as stripe returns the EPOCH date

    const defaultPeriodEndDate = _.get(activeUserToRequest, "stripe.period_end")

    const periodEndDate = plan === "none" ? momentTZ() : defaultPeriodEndDate;

    const finalRententionDate = momentTZ(periodEndDate)
      .clone()
      .add(60, "days")
      .endOf("day")
      .add(1, "second")
      .format("MMMM Do, YYYY");

    res.body = (
      <Upgrade2
        finalRententionDate={finalRententionDate}
        plan={plan}
        query={query}
        activeUser={activeUser}
      />
    );
  });
};

export default Upgrade2Controller;
